<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="展览名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="展览类型 :" prop="type">
              <el-select clearable v-model="form.type" placeholder="请选择">
                <el-option v-for="item in exhibitionTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state" label="楼层 :" prop="floor">
              <el-select clearable v-model="form.floor" placeholder="请选择">
                <el-option v-for="item in floorList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate('add')">
            <svg-icon icon-class="add" />&nbsp;新建可预约展览
          </el-button>

          <el-button class="el-primary-border" round @click="handleAddDate">
            <svg-icon icon-class="add" />&nbsp;新增可预约时间
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <!-- <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column> -->
          <el-table-column prop="name" label="展览名称" min-width="20%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="type" label="展览类型" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.type | filterType(exhibitionTypeList) }}</template>
          </el-table-column>

          <el-table-column prop="floor" label="楼层" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.floor | filterType(floorList) }}</template>
          </el-table-column>

          <el-table-column prop="exhibition" label="展厅" min-width="20%" show-overflow-tooltip></el-table-column>

          <el-table-column prop="isOpen" label="是否开放讲解预约" min-width="15%">
            <template slot-scope="scope">{{ scope.row.isOpen | filterIsOpen }}</template>
          </el-table-column>
          <el-table-column prop="num" label="可预约志愿者" min-width="15%">
            <template slot-scope="scope">{{ scope.row.num ? scope.row.num.split(',').length : 0 }}</template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="15%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleCreate('edit', scope.row.id)">编辑</a>
              <!-- <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>

      <el-dialog class="dialog-create-plan" :title="pageType == 'add' ? '新建可预约展览': '编辑可预约展览'" :visible.sync="dialogVisible" :before-close="cancel" width="850px">
        <div class="wrap">
          <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="145px" :rules="rules">
            <el-form-item label="展览类型 :" prop="type">
              <el-select clearable v-model="addForm.type" placeholder="请选择" @change="changeExhibiton">
                <el-option v-for="item in exhibitionTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="展览名称 :" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item v-if="exhibitionType == 2" label="关联临展 :" prop="recruitId">
              <el-select clearable v-model="addForm.recruitId" placeholder="请选择">
                <el-option v-for="item in temporaryData" :key="item.id" :label="item.exhibitionName" :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-input v-model="addForm.recruitId" placeholder="请输入"></el-input> -->
            </el-form-item>

            <el-form-item label="楼层 :" prop="floor">
              <el-select clearable v-model="addForm.floor" placeholder="请选择">
                <el-option v-for="item in floorList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="展厅 :" prop="exhibition">
              <el-input v-model="addForm.exhibition" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="是否开放讲解预约 :" prop="isOpen">
              <el-radio-group v-model="addForm.isOpen">
                <el-radio v-for="(item, index) in typeList" :label="item.dictCode" :key="index">{{item.dictName}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="选择可预约志愿者 :" prop="rang">
              <div class="setting-wrapper">
                <span class="name" v-for="(item,index) in selectedVolunters" :key="index">{{item.name}}</span>
                <span class="btn" @click="setVolunteer">设置</span>
              </div>
            </el-form-item>

            <!-- <h1>志愿者服务预约设置</h1> -->
            <el-form-item label="可预约时间 :" prop="weekly">
              <el-checkbox-group v-model="addForm.weekly">
                <el-checkbox-button v-for="week in weeks" :label="week.dictCode" :key="week.dictCode">{{week.dictName}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="可预约时段 :" prop="timePeriod">
              <el-select style="width: 100%;" clearable multiple v-model="addForm.timePeriod" placeholder="请选择">
                <el-option v-for="item in timePeriod" :key="item.dictCode" :label="item.dictName" :value="item.dictName">
                </el-option>
              </el-select>
              <!-- <div style="display: flex;align-items:center;margin-bottom: 20px" v-for="(item, index) in selectVal" :key="index">
                <el-select style="width: 100%;" clearable multiple  v-model="selectVal[index].value" placeholder="请选择" @change="changeTimePeriod">
                  <el-option v-for="item in timePeriod" :key="item.dictCode" :label="item.dictName" :value="item.dictName" :disabled="item.disabled">
                  </el-option>
                </el-select>
                <i class="el-icon-close" v-if="selectVal && selectVal.length > 1" @click='delTimePeriod(item, index)' style="margin-left: 10px"></i>
              </div>
              <el-button type="primary" @click="addTimePeriod" icon="el-icon-plus">添加</el-button> -->
            </el-form-item>

            <el-form-item label="新增可预约时段 :" prop="timePeriod1">
              <el-select style="width: 100%;" clearable multiple v-model="timePeriod1" placeholder="请选择">
                <el-option v-for="item in addTimePeriod" :key="item.dictCode" :label="item.dictName" :value="item.dictName">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="不可预约日期 :" prop="noAppointmentDate">
              <el-date-picker style="width:100%" clearable v-model="addForm.noAppointmentDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="dates" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="footer mt-30">
          <el-button @click="cancel">取消</el-button>
          <el-button @click="submit('form')" type="primary" :loading="loadingSave">确定</el-button>
        </div>
      </el-dialog>

      <dialogAdultVolunteer ref="dialogAdultVolunteer" @setNum="setVulunteerNum"></dialogAdultVolunteer>
      <dialogAddDate ref="dialogAddDate"></dialogAddDate>

    </div>

  </div>
</template>

<script>
import dialogAdultVolunteer from './dialog-adult-volunteer'
import dialogAddDate from './dialog-add-date'

export default {
  components: {
    dialogAddDate,
    dialogAdultVolunteer
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        type: '',
        floor: ''
      },
      addForm: {
        name: '',
        type: '',
        isOpen: '',
        floor: '',
        exhibition: '',
        timePeriod: [],
        weekly: [],
        noAppointmentDate: []
      },
      selectVal: [{ value: '' }],
      rules: {
        type: [
          { required: true, message: '展览类型不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '展览名称不能为空', trigger: 'blur' }
        ],
        floor: [{ required: true, message: '楼层不能为空', trigger: 'blur' }],
        exhibition: [
          { required: true, message: '展厅不能为空', trigger: 'blur' }
        ],
        isOpen: [
          { required: true, message: '开放讲解预约不能为空', trigger: 'blur' }
        ]
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      typeList: [
        {
          dictCode: 1,
          dictName: '是'
        },
        {
          dictCode: 0,
          dictName: '否'
        }
      ],
      exhibitionTypeList: [
        { dictCode: '1', dictName: '基本陈列' },
        { dictCode: '2', dictName: '临时展览' }
      ],
      floorList: [
        { dictCode: '1', dictName: '一层' },
        { dictCode: '2', dictName: '二层' },
        { dictCode: '3', dictName: '三层' },
        { dictCode: '4', dictName: '四层' }
      ],
      detailId: '',
      pageType: '',
      weeks: [],
      timePeriod: [],
      timePeriod1: [],
      addTimePeriod: [],
      chooseRowIds: '',
      total: 0,
      exhibitionType: '',
      tableData: [],
      temporaryData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      selectedVolunters: [],
      listLoading: true,
      loadingSave: false,
      dialogVisible: false
    }
  },
  filters: {
    filterIsOpen(open) {
      if (open == 1) {
        return '是'
      } else if (open == 0) {
        return '否'
      }
    },
    filterVolunteerStatus(status, that) {
      let obj = that.levelList.filter((item) => {
        return item.dictCode == status
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    },

    filterType(type, list) {
      let obj = list.filter((item) => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return type
    },

    filterTime(time) {
      return time.slice(0, 10)
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.listLoading = true
      this.tableData = []
      this.$api.volunteer
        .getExhibitionList({
          ...this.form,
          serviceType: '1',

          ...this.listQuery
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.listLoading = false
        })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '删除',
          content: '请谨慎操作，删除展览会一并删除用户预约数据'
        },
        () => {
          this.$api.volunteer.deleteExhibition({ id }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    changeExhibiton(type) {
      this.exhibitionType = type
      if (type == 2) {
        this.getTemporaryList()
      }
    },

    setVulunteerNum(num) {
      console.log(num)
      let ids = []
      this.selectedVolunters = num
      num.forEach((item) => {
        ids.push(item.id)
      })
      this.addForm.num = ids.join(',')
    },

    // changeTimePeriod(val) {
    //   this.timePeriod.map(it => {
    //     it.disabled = false
    //     this.selectVal.map(item => {
    //       if (it.dictName == item.value) {
    //         it.disabled = true
    //       }
    //     })
    //   })

    // },

    // delTimePeriod(obj, dx) {
    //   this.selectVal.splice(dx, 1)
    //   this.timePeriod.map((item, index) => {
    //     if (obj.value == item.dictName) {
    //       item.disabled = false
    //     }
    //   })
    // },

    handlePublish(item) {
      this.$api.volunteer
        .publishNotice({ id: item.id, status: item.status == '0' ? '1' : '0' })
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleAddDate() {
      this.$refs.dialogAddDate.init()
    },

    handleCreate(type, id) {
      this.pageType = type
      if (id) {
        this.detailId = id
        this.getDetail()
      }
      this.dialogVisible = true
    },

    getDetail() {
      this.$api.volunteer
        .getExhibitionDetail({ id: this.detailId })
        .then((res) => {
          if (res.success) {
            if (res.result) {
              let arr1 = [],
                arr2 = []
              if (res.result.bsVolunteerV2Exhibition) {
                let exhibitionInfo = res.result.bsVolunteerV2Exhibition
                this.addForm = exhibitionInfo
                if (exhibitionInfo.weekly) {
                  this.addForm.weekly = exhibitionInfo.weekly.split(',')
                }

                if (exhibitionInfo.noAppointmentDate) {
                  this.addForm.noAppointmentDate =
                    exhibitionInfo.noAppointmentDate.split(',')
                }

                if (exhibitionInfo.timePeriod) {
                  let temp = exhibitionInfo.timePeriod.split(',')
                  temp.map((item) => {
                    let flag1 = this.timePeriod.some((it1) => {
                      return it1.dictName == item
                    })

                    if (flag1) {
                      arr1.push(item)
                    }

                    let flag2 = this.addTimePeriod.some((it1) => {
                      return it1.dictName == item
                    })

                    if (flag2) {
                      arr2.push(item)
                    }
                  })
                  this.addForm.timePeriod = arr1
                  this.timePeriod1 = arr2
                }
              }
              if (res.result.volunteerV2Informations) {
                this.selectedVolunters = res.result.volunteerV2Informations
                let ids = []
                this.selectedVolunters.forEach((item) => {
                  ids.push(item.id)
                })
                this.addForm.num = ids.join(',')
              }
            }
          }
        })
    },

    initSelectList() {
      let weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      for (let m = 1; m <= 7; m++) {
        this.weeks.push({
          dictCode: m.toString(),
          dictName: weeks[m - 1]
        })
      }

      let addTimePeriod = [
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30'
      ]
      for (let m = 0; m < addTimePeriod.length; m++) {
        this.addTimePeriod.push({
          dictCode: m.toString(),
          dictName: addTimePeriod[m]
        })
      }

      this.$api.common
        .getSelectDataByKey({ key: 'time_interval' })
        .then((res) => {
          if (res.success) {
            this.timePeriod = res.result
            res.result.map((item) => {
              this.addForm.timePeriod.push(item.dictName)
            })
          }
        })
    },

    getTemporaryList() {
      this.$api.volunteer
        .getVolunteerRecruitList({
          currentPage: 1,
          size: 9999,
          serviceType: '4'
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            this.temporaryData = res.result.records
          }
        })
    },

    setVolunteer() {
      console.log(34354)
      if (this.exhibitionType == 2 && !this.addForm.recruitId) {
        this.$message.warning('请选择临时展览')
        return
      }
      if (this.exhibitionType == 2) {
      }
      this.$refs.dialogAdultVolunteer.init(
        JSON.parse(JSON.stringify(this.selectedVolunters)),
        this.addForm.recruitId
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach((item) => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    cancel() {
      this.dialogVisible = false
      this.$refs['addForm'].resetFields()
      // this.selectVal = [{ value: '' }]
      // this.addForm = { weekly: [] }
      this.selectedVolunters = []
    },

    submit() {
      let url,
        timePeriod = []
      if (this.timePeriod1 && this.timePeriod1.length > 0) {
        timePeriod = this.addForm.timePeriod.concat(this.timePeriod1)
      } else {
        timePeriod = this.addForm.timePeriod
      }

      this.$refs['addForm'].validate((vaild) => {
        if (vaild) {
          let param = {
            serviceType: '1',
            type: this.addForm.type,
            floor: this.addForm.floor,
            exhibition: this.addForm.exhibition,
            name: this.addForm.name,
            isOpen: this.addForm.isOpen,
            num: this.addForm.num,
            weekly: this.addForm.weekly ? this.addForm.weekly.join(',') : '',
            timePeriod: timePeriod ? timePeriod.join(',') : '',
            noAppointmentDate: this.addForm.noAppointmentDate
              ? this.addForm.noAppointmentDate.join(',')
              : ''
          }

          if (this.exhibitionType == 2) {
            param.recruitId = this.addForm.recruitId
          }
          if (this.pageType === 'edit') {
            url = 'editExhibition'
            param.id = this.detailId
          } else {
            url = 'addExhibition'
          }
          this.loadingSave = true
          this.$api.volunteer[url](param)
            .then((res) => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('展厅编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('新增展厅成功')
                }
                this.cancel()
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    handleBeforeClose() {
      this.dialogVisible = false
      this.selectVal = [{ value: '' }]
      this.$refs['addForm'].clearValidate()
      this.addForm = { weekly: [] }
      this.selectedVolunters = []
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.initList()
    this.initSelectList()

    window.addEventListener('keyup', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.setting-wrapper {
  min-height: 100px;
  padding: 0 15px;
  border: 1px solid #ebedf2;
  .name {
    margin-right: 10px;
  }
  .btn {
    background: $primary;
    padding: 5px 10px;
    color: #fff;
    cursor: pointer;
  }
}

.el-form-state {
  /deep/ .el-form-item__label {
    width: 60px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
  }
}
</style>